module.exports = __webpack_public_path__ + "img/loading.a43e90b8.svg";